import React, { useState } from 'react';
import useProductSearch from '../../hooks/useProductSearch';
import ProductList from '../../components/ProductList';
import { Container, InputGroup, FormControl, Button } from 'react-bootstrap';

const ProdutosML = () => {
    const [query, setQuery] = useState('');
    const { products, searchProducts, loading, error, page, setPage, totalPages } = useProductSearch();

    const handleSearch = () => {
        searchProducts(query, 1); // Sempre busca da primeira página
    };

    const handlePageChange = (newPage) => {
        searchProducts(query, newPage);
        setPage(newPage); // Atualiza a página atual
    };

    return (
        <Container>
            <InputGroup className="mb-3">
                <FormControl
                    placeholder="Pesquisar produtos"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <Button variant="primary" onClick={handleSearch}>
                    Buscar
                </Button>
            </InputGroup>
            
            {loading && <p>Carregando...</p>}
            {error && <p>Ocorreu um erro: {error.message}</p>}
            <ProductList
                products={products}
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </Container>
    );
};

export default ProdutosML;
